//Componentes Generales
import React, { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import productsContext from "../../context/productos/productsContext";
import agregarReqContext from "../../context/agregarReq/agregarReqContext";
import authContext from "../../context/authentication/authContex";
import FormReq from "../../components/FormReq/FormReq";

// Alertas
import Swal from 'sweetalert2'

//Estilos
import "./AddReq.css"

/* 
    Vista donde se gestiona toda la lógica para añadir un requerimiento.
        Donde reqEdit no esta en uso.
              cerrar no esta en uso.
*/
function AddReq({ reqEdit, cerrar }) {

    //Context de Autenticacion   
    const aContext = useContext(authContext);
    const { usuario: user } = aContext;

    //Context productos
    const pContext = useContext(productsContext);
    const { products, actualizarProducts } = pContext;
    
    //Context agregar requerimiento
    const addContext = useContext(agregarReqContext);
    const { req, guardarRequerimiento, guardarRequerimientoFromProcs, itemsList } = addContext;

    const location = useLocation();
    const {procedimiento, procedimientos, ordenTrabajoToHandle, mode} = location.state || {};

    /* 
        Disparador que actualiza la lista de productos disponibles al momento de renderizar el componente.
    */
    useEffect(() => {
        const fn = async () => {
            await actualizarProducts();
        }
        fn();
    }, []);
    
    /* 
        Función encargada de validar los campos de un requerimiento a guardar.
        Donde r es el requerimiento.
        i son los items del requerimiento.
        Retorna una respuesta.
    */
    const validacionesCampos = (r, i) => {
        let resp = '';
        if(r.title === ""){
            resp = "Falta ingresar titulo de Orden de Compra";
        }
        return resp;
    }

    /* 
        Función encargada de guardar el requerimiento.
            Donde requeriment es el requerimiento a guardar.
                  items son los items del requerimiento.
                  files son los arhivos adjuntos.
    */
    const handleSaveReq = async (requeriment, files) =>{
        let productosCompletados = requeriment.productos.filter(p => p.artCod != '');
        let tareasCompletadas = requeriment.tareas.filter(t => t.label != '');
        let imputacionesCompletadas = requeriment.imputaciones.filter(i => i.legajo.value != '');
        let reqModelado = {...requeriment,productos:productosCompletados,tareas:tareasCompletadas,imputaciones:imputacionesCompletadas};
        const msj = validacionesCampos(reqModelado, productosCompletados);
        
        if (requeriment !== undefined && requeriment !== null) {
            if (msj === "") {
                // ODT sobre procedimientos programados: el backend crea y vincula en un mismo request.
                const procsProgramados = (procedimiento && Object.keys(procedimiento).length > 0) ? [procedimiento] : (procedimientos ?? []);
                if(procsProgramados.length > 0){
                    const respProcs = await guardarRequerimientoFromProcs(reqModelado, productosCompletados, user, files, procsProgramados);
                    if(!respProcs.status){
                        Swal.fire({
                            title: 'No se pudo guardar la orden de trabajo',
                            icon: 'error',
                            text: respProcs.msg,
                            showConfirmButton: true,
                            allowEnterKey: true
                        });
                        return false;
                    }
                    Swal.fire({
                        title: `Se guardo una nueva orden de trabajo!`,
                        icon: respProcs.msg ? 'warning' : 'success',
                        text: respProcs.msg ?? `El numero de orden de trabajo es : ${respProcs.data.tDocNroFor}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    return respProcs.data;
                }

                const resp = await guardarRequerimiento(reqModelado, productosCompletados, user, files);
                Swal.fire({
                    title: `Se guardo una nueva orden de trabajo!`,
                    icon: 'success',
                    text: `El numero de orden de trabajo es : ${resp.tDocNroFor}`,//${resp.tDocNroFor}
                    showConfirmButton: true,
                    allowEnterKey: true
                });
                return resp;
            }else{
                Swal.fire({
                    title: msj,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
                return false;
            }
        }else{
            return false;
        }
    }

    return (
        <div style={{ margin: '0px 100px', height:"100%"}}>
            <FormReq req={(ordenTrabajoToHandle != undefined && Object.keys(ordenTrabajoToHandle).length > 0) ? ordenTrabajoToHandle : reqEdit ? reqEdit : undefined} guardarReq={handleSaveReq} cerrar={cerrar} procedimiento={procedimiento} procedimientos={procedimientos} mode={(ordenTrabajoToHandle != undefined && Object.keys(ordenTrabajoToHandle).length > 0) ? 'editOTFromActivos' : 'normal'}/>
        </div>
    );
}

export default AddReq